export const common = {
  // Navigation
  aboutUs: '关于我们',
  services: '服务',
  brands: '品牌',
  marketInsights: '市场洞察',
  contact: '联系我们',
  
  // Hero Section
  heroTitle: '连接欧洲时尚与中国市场',
  heroSubtitle: 'XINRUNMODA为欧洲品牌和中国零售渠道搭建桥梁',
  getStarted: '开始合作',
  learnMore: '了解更多',
  
  // About Section
  whoWeAre: '关于我们',
  aboutDescription1: '利用香港作为国际贸易枢纽的作用，XINRUNMODA连接欧洲品牌和中国零售渠道。我们精选优质欧洲时尚，提供可靠的端到端供应链服务。',
  aboutDescription2: '我们在香港的战略位置使我们能够完美理解欧洲时尚卓越性和中国市场动态，实现无缝的跨文化商业关系。',
  partnerBrands: '合作品牌',
  retailPartners: '零售伙伴',
  
  // Services Section
  ourServices: '我们的服务',
  servicesDescription: '从品牌引入到市场推广，我们提供全方位的时尚贸易解决方案',
  brandSourcing: '品牌采购',
  brandSourcingDesc: '精选优质欧洲时尚品牌，为中国市场提供独特产品',
  supplyChain: '供应链管理',
  supplyChainDesc: '端到端物流解决方案，确保产品及时高效交付',
  marketEntry: '市场进入',
  marketEntryDesc: '协助欧洲品牌进入中国市场，提供本地化支持',
  retailNetwork: '零售网络',
  retailNetworkDesc: '广泛的零售合作伙伴网络，覆盖中国主要城市',
  
  // Brands Section
  featuredBrands: '精选品牌',
  brandsDescription: '我们与欧洲顶级时尚品牌合作，为中国消费者带来最新潮流',
  
  // Market Insights Section
  marketInsightsTitle: '市场洞察',
  marketInsightsDescription: '深入了解中国时尚市场趋势和消费者偏好',
  
  // Contact Section
  contactTitle: '联系我们',
  contactDescription: '准备开始您的时尚贸易之旅？让我们讨论如何帮助您的品牌在中国市场取得成功。',
  getInTouch: '联系我们',
  ourLocation: '我们的位置',
  emailUs: '邮件联系',
  
  // Footer
  footerDescription: 'XINRUNMODA - 连接欧洲时尚与中国市场的专业贸易公司',
  quickLinks: '快速链接',
  contactInfo: '联系信息',
  followUs: '关注我们',
  allRightsReserved: '版权所有'
};